package della8.core.support

@JsModule("@js-joda/timezone")
@JsNonModule
external object JsJodaTimeZoneModule

val jsJodaTz = JsJodaTimeZoneModule